module.exports = "teamroom-people"